import warehouse from '@/api/stock/warehouse'

import { baseState, baseMutations } from '@/store/mixins'
import { isEmpty } from "lodash";

export const state = {
  ...baseState,
  branch_id: [],
}

export const getters = {
}

export const mutations = {
  ...baseMutations,
  SET_BRANCH_ID(state, value) {
    state.branch_id = value
  },
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        filter: {
          search: context.state.search,
          branch_id: context.state.branch_id
        }
      },
      attrubutes
    )
    return warehouse.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return warehouse.store(data)
  },
  update(context, { id, data }) {
    return warehouse.update(id, data)
  },
  async find(context, id) {
    if (isEmpty(context.state.edit_data)) {
      let response = await warehouse.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  destroy(context, id) {
    return warehouse.destroy(id)
  },
}
